module.exports = __webpack_public_path__ + "img/125.0529356f.jpg";